import React from 'react';
import DownloadButton from '@/storybook/components/DownloadButton/DownloadButton';
import { useDownloadDataButton } from './dataDownloadUtils';
import { DownloadButtonProps } from '@/types/download/DownloadButtonProps';

const DownloadDataButton: React.FC<DownloadButtonProps> = props => {
  const { disabled, className, 'data-testid': dataTestId, ...dataProps } = props;

  const onDownload = useDownloadDataButton(dataProps);

  return <DownloadButton onDownload={onDownload} disabled={disabled} className={className} data-testid={dataTestId} />;
};

export default DownloadDataButton;
